// extracted by mini-css-extract-plugin
module.exports = {"container":"FlightSearchFormFlat_container__aHzk_"};